<template>
  <li class="group-container">
    <span @click="toggleDropdown" class="menu-item" :class="{ active: isActive }">
      <div class="content">
        <img :src="`/icons/${linkIcon}.svg`" alt="Link Icon">
        <span v-if="!isCollapsed">{{ linkText }}</span>
      </div>

      <i v-if="!isCollapsed" :class="iconClass" class="fa"></i>
    </span>

    <ul v-if="!isCollapsed && isDropdownVisible">
      <li v-for="(item, index) in dropdownLinks" :key="index">
        <router-link class="group-item" :class="{ active: isActiveLink(item.link) }" :to="item.link">
          <span>{{ item.text }}</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
export default {
  props: {
    linkText: {
      type: String,
      required: true
    },
    linkIcon: {
      type: String,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      required: true,
    },
    dropdownLinks: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      isDropdownVisible: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible

      this.$emit('toggleSidebar')
    },
    isActiveLink(link) {
      return this.$route.name === link.name
    },
    isAnyChildLinkActive() {
      return this.dropdownLinks.some((item) => this.isActiveLink(item.link));
    },
  },
  computed: {
    iconClass() {
      return this.isDropdownVisible ? 'fa-angle-up' : 'fa-angle-down'
    },
    isActive() {
      return this.isAnyChildLinkActive();
    }
  },
  watch: {
    $route() {
      if (!this.isAnyChildLinkActive()) {
        this.isDropdownVisible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.group-container {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;

  font-weight: 600;

  ul {
    padding: 0;
    list-style: none;

    display: flex;
    flex-direction: column;
    gap: 0.625rem;

    li a.active {
      span {
        color: #FFC20E;
      }
    }

    li {
      display: flex;

      &:hover {
        .group-item span {
          color: #FFC20E;
        }
      }

      .group-item {
        flex: 1;
        padding: 0.375rem 2rem;

        span {
          font-size: 0.875rem;
          color: #FFF;
        }
      }
    }
  }
}

.menu-item {
  all: unset;
  padding: 0.8125rem 1rem;

  display: flex;
  justify-content: space-between;
  align-items: center;

  text-decoration: none;
  color: white;
  background: transparent;

  img {
    min-width: 1.375rem;
    width: 1.375rem;
  }

  span {
    font-size: 0.875rem;
  }

  &.active,
  &:hover {
    background: #4D68B0;
    border: 0;
    border-radius: 6px;
    cursor: pointer;
  }

  .content {
    display: flex;
    align-items: center;
    gap: 1rem;
  }
}

.fa {
  transition: transform 0.3s ease-in-out;
}
</style>
